module.exports = __webpack_public_path__ + "static/media/icon-snappy.19125bd7.svg";